<script>
import drawerItems from '@src/data/drawer-items.json'
import { authComputed } from '@state/helpers'

export default {
  data() {
    return {
      drawerItems,
    }
  },

  computed: {
    ...authComputed,
    drawer: {
      get() {
        return this.$store.state.app.drawer
      },
      set(val) {
        this.$store.commit('app/SET_DRAWER', val)
      },
    },
  },

  methods: {
    can(permission) {
      return this.havePermission(permission)
    },
  },
}
</script>

<template>
  <VNavigationDrawer v-model="drawer" app clipped fixed class="grey lighten-3">
    <VList dense>
      <template v-for="(nav, i) in drawerItems">
        <VLayout v-if="nav.heading" :key="i" align-center row>
          <VFlex xs6>
            <VSubheader v-if="nav.heading">
              {{ nav.heading }}
            </VSubheader>
          </VFlex>
        </VLayout>
        <VDivider v-else-if="nav.divider" :key="i" dark class="my-3" />
        <template v-else>
          <VListTile
            v-if="isAdmin || can(nav.permission)"
            :key="i"
            :to="{ name: nav.to }"
            exact
            active-class="gold--text"
          >
            <VListTileAction>
              <VIcon>{{ nav.icon }}</VIcon>
            </VListTileAction>
            <VListTileContent>
              <VListTileTitle>{{ nav.text }}</VListTileTitle>
            </VListTileContent>
          </VListTile>
        </template>
      </template>
    </VList>
  </VNavigationDrawer>
</template>
